import React, { useState } from "react";
import msabahaData from "./MasbahaData";
import styled from "styled-components";
import { Button } from "../../Button/Button";
import { BiReset } from "react-icons/bi";
import { Container } from "../../Container/Container";
import Navbar from "../../Navbar/Navbar";

const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  cursor: pointer;
  /* column-gap: 30px; */
`;

const Reset = styled.div`
  .button {
    justify-content: center;
    padding: 15px;
    font-size: 16px;

    svg {
      margin-right: 10px;
      font-size: 22px;
    }
  }
`;

const Counter = styled.div`
  border-radius: 50%;
  border-top: 2px solid rgba(var(--sec-color-rgba), 0.5);
  border-left: 2px solid rgba(var(--sec-color-rgba), 0.5);
  border-bottom: 2px solid transparent;
  border-right: 2px solid transparent;
  box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  width: 250px;
  height: 250px;
  margin: 0 auto;
  user-select: none;
`;
const Start = styled.div`
  background-color: transparent;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
function Masbaha() {
  const [counter, setCounter] = useState(0);

  const count = () => {
    setCounter(counter + 1);
  };

  const reset = () => {
    setCounter(0);
  };

  // let start;
  // counter >= 1 ? (start = "") : (start = msabahaData.start);

  return (
    <>
      <Navbar brand={msabahaData.brand} />
      <Container>
        <Reset onClick={reset}>
          <Button btnSize="btn--full-width" btnStyle="btn--hovered">
            {msabahaData.reset}
            <BiReset />
          </Button>
        </Reset>
        <Content onClick={count}>
          <Counter>{counter}</Counter>
          <Start>{msabahaData.start}</Start>
        </Content>
      </Container>
    </>
  );
}

export default Masbaha;
